import LinearProgressWithLabel from './LinearProgressWithLabel';

export default LinearProgressWithLabel;
